module.exports = __webpack_public_path__ + "img/altamira.1c51a2b3.png";